import React from 'react';
import { Flex, Img } from 'pounceV2';
import { useTheme } from '@mui/material';
import logoDark from 'Assets/panther-minimal-logo.svg';
import logoLight from 'Assets/panther-minimal-logo-light.svg';

const getStoredIsDark = () => {
  const stored = localStorage.getItem('panther.generalSettings.theme');
  if (stored === 'light') {
    return false;
  }
  if (stored === 'system') {
    return !window.matchMedia('(prefers-color-scheme: light)').matches;
  }
  return true; // default: dark
};

const FallbackLoadingV3 = () => {
  const theme = useTheme();
  const tokens = theme?.palette?.tokens;
  // When V3 tokens are available trust palette.mode; otherwise read localStorage
  // directly (same logic as index.ejs) because the V2 theme doesn't set palette.mode reliably.
  const isDark = tokens ? theme.palette.mode !== 'light' : getStoredIsDark();
  const canvasBg = tokens?.background.neutral.canvas.base ?? (isDark ? '#141c2a' : '#f8f9fc');
  const logo = isDark ? logoDark : logoLight;

  return (
    <Flex
      justify="center"
      align="center"
      bg={canvasBg}
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        zIndex: 9999,
      }}
    >
      <Img src={logo} alt="Panther logo" nativeHeight={150} />
    </Flex>
  );
};

export default FallbackLoadingV3;
